import { createSelector } from "@reduxjs/toolkit";

import { IStoreState } from "App/types";
import { IDataKeys, IPaginationItem } from "shared/types";

import { build as buildObject, IReducer } from "shared/utils";
import { IVenueActions } from "Venues/types";

const baseSelector = (state: IStoreState) => state.data;

export const dataSelector = createSelector([baseSelector], data => data.data);
export const metaSelector = createSelector([baseSelector], data => data.meta);
export const paginationSelector = createSelector([baseSelector], data => data.pagination);

export const dataMetaSelectorHelper = (action: string) =>
  createSelector(metaSelector, meta => meta?.[action] || {});

export const dataMetaSelector = (action: IVenueActions) => dataMetaSelectorHelper(action);

export const dataPaginationSelectorHelper = (key: string) =>
  createSelector(
    paginationSelector,
    pagination => (pagination?.[key] as IPaginationItem) || ({} as IPaginationItem)
  );

export const dataPaginationSelector = (key: string) => dataPaginationSelectorHelper(key);

export const buildData = (data: IReducer, key: IDataKeys, id?: string) =>
  buildObject(data, key, id);
